import React from 'react';
import Button from '@bitcoin-portal/bitcoincom-pkg-components/dist/Button';
import { ButtonWrapper, Wrapper, Link } from './styled';
import { sendGaEvent } from '../../helpers';
const Buttons = ({ contrast = false, isMobile = false, buttons }) => {
    return (React.createElement(Wrapper, { isMobile: isMobile },
        React.createElement(ButtonWrapper, { isMobile: isMobile }, buttons.map(({ id, label, url, design }) => id === 'login' ? (React.createElement(Link, { key: id, contrast: contrast, href: url, onClick: () => {
                sendGaEvent({
                    category: 'Account',
                    action: 'Sign in',
                    label: 'Header',
                });
            } },
            React.createElement("span", null, label))) : (React.createElement(Button, { key: id, design: design, className: "universal-menu-link", href: url, size: "small", onClick: () => {
                if (id === 'create') {
                    sendGaEvent({
                        category: 'Account',
                        action: 'Create account',
                        label: 'Header',
                    });
                }
            } },
            React.createElement("span", null, label)))))));
};
export default Buttons;
//# sourceMappingURL=Buttons.js.map